import type { ComponentPropsWithoutRef, ElementType, ReactNode } from "react";
import clsx from "clsx";
import styles from "./GlassPanel.module.scss";

/* UI-DESIGN: one frosted-glass primitive for every panel that floats on the
   lightbox, so blur, border and highlight stay identical. LB-19 it is the
   only one: nav, hero, case cards, How it works and Host all use it.
   `variant="card"` (default) is the denser fill for text; `"panel"` the
   thinner frost for chrome like the nav. */
type GlassPanelProps<T extends ElementType> = {
  as?: T;
  variant?: "panel" | "card";
  className?: string;
  children?: ReactNode;
} & Omit<ComponentPropsWithoutRef<T>, "as" | "className" | "children">;

const GlassPanel = <T extends ElementType = "div">({
  as,
  variant = "card",
  className,
  children,
  ...rest
}: GlassPanelProps<T>) => {
  const Tag = (as ?? "div") as ElementType;
  return (
    /* UI-DESIGN: LB-15 `data-lb-glass` tells the scene the cursor is on
       glass, not on a slide under it */
    <Tag className={clsx(styles.glass, styles[variant], className)} data-lb-glass="" {...rest}>
      {children}
    </Tag>
  );
};

export default GlassPanel;
